import React, { useState } from 'react';
import { usePeriod } from '../../../../hooks/usePeriod';
import { usePeriodReturn } from '../../../../components/PeriodReturn/usePeriodReturn';
import { Box } from '../../../../../CommonComponents/OPL/Box/Box';
import { ValueVsInvestmentChart } from '../../../../components/ValueVsInvestmentChart/ValueVsInvestmentChart';
import { MobileAccountsList } from '../../../../components/MobileAccountsList/MobileAccountsList';
import { RelatedHouseholds } from '../../../../../ContextualSidebar/NetWorthSidebar/components/RelatedHouseholds/RelatedHouseholds';
import { Text } from '../../../../../CommonComponents/OPL/Text/Text';
import { PerformanceSummary } from '../../../../components/PerformanceSummary/PerformanceSummary';
import { AssetAllocationChart } from '../../../../components/AssetAllocationChart/AssetAllocationChart';
import { MobileHelperText } from '../../../../components/MobileHelperText/MobileHelperText';
import { useValidatePeriod } from '../../../../hooks/useValidatePeriod';
import { usePerformanceReportingContext } from '../../../../context/usePerformanceReportingContext';
import { useRouteParams } from '../../../../hooks/useRouteParams';
import { MobilePageWrapper } from '../../../../AccountPerformanceReporting.styles';
import { useIsEmbeddedMobile } from '../../../../../_hooks/useIsEmbeddedMobile';
import { MobileHeader } from '../../../../components/MobileHeader/MobileHeader';
import { PeriodSelector } from '../../../../components/PeriodSelector/PeriodSelector';

export const SummaryMobile = () => {
  const isEmbeddedMobile = useIsEmbeddedMobile();
  const [selectedDate, setSelectedDate] = useState<string | null>(null);

  const { focusedAccountId, updatedAt, selectedItemName } = usePerformanceReportingContext();

  useValidatePeriod();

  const { label: periodLabel } = usePeriod();
  const { data: periodReturnData } = usePeriodReturn();

  const portfolioReturn = periodReturnData?.value ? parseFloat(periodReturnData?.value) : null;

  const { clientId } = useRouteParams();

  return (
    <>
      <MobilePageWrapper>
        <Box>
          <Box mx="16" mb="12">
            <MobileHeader
              label={selectedItemName}
              subLabel={selectedDate || `Last updated: ${updatedAt}`}
              isHighlighted={!!selectedDate}
            />
          </Box>

          <Box px="16" mt="12">
            <PeriodSelector isVerticalLayout />
          </Box>
        </Box>

        <Box>
          <ValueVsInvestmentChart
            portfolioReturn={portfolioReturn}
            setSelectedDate={setSelectedDate}
          />
        </Box>

        {!focusedAccountId && <MobileAccountsList clientId={clientId} updatedAt={updatedAt} />}

        <Box>
          <RelatedHouseholds clientId={clientId} />
        </Box>

        <Box borderTop={isEmbeddedMobile ? '1px solid' : '0'} borderColor="neutral.200">
          <Text variant="cardTitle" p="12">
            Activity Summary{' '}
            <Text display="inline-block" fontWeight={600} color="neutral.500">
              • {periodLabel}
            </Text>
          </Text>

          <PerformanceSummary isTransactions />
        </Box>

        <Box display="flex" flexDirection="column">
          <AssetAllocationChart tab="left" />
        </Box>

        <Box display="flex" flexDirection="column">
          <AssetAllocationChart tab="right" />
        </Box>
      </MobilePageWrapper>

      <MobileHelperText />
    </>
  );
};
